import React, { useEffect } from 'react';
import { Row, Col, Nav } from 'react-bootstrap';
import { useParams, useNavigate } from 'react-router-dom';
import DashboardLayout from '../components/dashboard/DashboardLayout';
import GeneralSettingsTab from './settings/GeneralSettingsTab';
import QuickBooksTab from './settings/QuickBooksTab';
import MercuryTab from './settings/MercuryTab';
import FileBankAccountsTab from './settings/FileBankAccountsTab';
import HubSpotTab from './settings/HubSpotTab';
import GoogleSheetsTab from './settings/GoogleSheetsTab';
import SlingTab from './settings/SlingTab';
import SendGridTab from './settings/SendGridTab';
import USPSTab from './settings/USPSTab';
import HarvestSettingsTab from './settings/HarvestSettingsTab';
import WebFormsTab from './settings/WebFormsTab';
import MonitoringTab from './settings/MonitoringTab';
import WebMonTab from './settings/WebMonTab';
import SMTPTab from './settings/SMTPTab';

const validTabs = ['general', 'quickbooks', 'mercury', 'file-bank-accounts', 'hubspot', 'googlesheets', 'getsling', 'sendgrid', 'usps', 'harvest', 'web-forms', 'smtp', 'certmon', 'webmon'];

const SystemSettings: React.FC = () => {
  const { tab } = useParams<{ tab: string }>();
  const navigate = useNavigate();
  const activeTab = tab && validTabs.includes(tab) ? tab : 'general';

  useEffect(() => {
    if (!tab || !validTabs.includes(tab)) {
      navigate('/admin/settings/general', { replace: true });
    }
  }, [tab, navigate]);

  const navTo = (t: string) => navigate(`/admin/settings/${t}`, { replace: true });

  const stickyHeaderContent = (
    <Nav variant="tabs" className="mb-0">
      <Nav.Item><Nav.Link active={activeTab === 'general'} onClick={() => navTo('general')}>General</Nav.Link></Nav.Item>
      <Nav.Item><Nav.Link active={activeTab === 'quickbooks'} onClick={() => navTo('quickbooks')}>QuickBooks</Nav.Link></Nav.Item>
      <Nav.Item><Nav.Link active={activeTab === 'mercury'} onClick={() => navTo('mercury')}>Mercury Bank</Nav.Link></Nav.Item>
      <Nav.Item><Nav.Link active={activeTab === 'file-bank-accounts'} onClick={() => navTo('file-bank-accounts')}>File Bank Accounts</Nav.Link></Nav.Item>
      <Nav.Item><Nav.Link active={activeTab === 'hubspot'} onClick={() => navTo('hubspot')}>HubSpot</Nav.Link></Nav.Item>
      <Nav.Item><Nav.Link active={activeTab === 'googlesheets'} onClick={() => navTo('googlesheets')}>Google Sheets</Nav.Link></Nav.Item>
      <Nav.Item><Nav.Link active={activeTab === 'getsling'} onClick={() => navTo('getsling')}>GetSling</Nav.Link></Nav.Item>
      <Nav.Item><Nav.Link active={activeTab === 'sendgrid'} onClick={() => navTo('sendgrid')}>SendGrid</Nav.Link></Nav.Item>
      <Nav.Item><Nav.Link active={activeTab === 'usps'} onClick={() => navTo('usps')}>USPS</Nav.Link></Nav.Item>
      <Nav.Item><Nav.Link active={activeTab === 'harvest'} onClick={() => navTo('harvest')}>Applicant Harvest</Nav.Link></Nav.Item>
      <Nav.Item><Nav.Link active={activeTab === 'web-forms'} onClick={() => navTo('web-forms')}>Web Forms</Nav.Link></Nav.Item>
      <Nav.Item><Nav.Link active={activeTab === 'certmon'} onClick={() => navTo('certmon')}>Certificate Monitoring</Nav.Link></Nav.Item>
      <Nav.Item><Nav.Link active={activeTab === 'webmon'} onClick={() => navTo('webmon')}>Website Monitoring</Nav.Link></Nav.Item>
      <Nav.Item><Nav.Link active={activeTab === 'smtp'} onClick={() => navTo('smtp')}>SMTP</Nav.Link></Nav.Item>
    </Nav>
  );

  return (
    <DashboardLayout
      title="System Settings"
      subtitle="Configure system-wide settings and preferences"
      stickyHeader={stickyHeaderContent}
      scrollable
    >
      <Row className="mb-4">
        <Col>
          {activeTab === 'general' && <GeneralSettingsTab />}
          {activeTab === 'quickbooks' && <QuickBooksTab />}
          {activeTab === 'mercury' && <MercuryTab />}
          {activeTab === 'file-bank-accounts' && <FileBankAccountsTab />}
          {activeTab === 'hubspot' && <HubSpotTab />}
          {activeTab === 'googlesheets' && <GoogleSheetsTab />}
          {activeTab === 'getsling' && <SlingTab />}
          {activeTab === 'sendgrid' && <SendGridTab />}
          {activeTab === 'usps' && <USPSTab />}
          {activeTab === 'harvest' && <HarvestSettingsTab />}
          {activeTab === 'web-forms' && <WebFormsTab />}
          {activeTab === 'certmon' && <MonitoringTab />}
          {activeTab === 'webmon' && <WebMonTab />}
          {activeTab === 'smtp' && <SMTPTab />}
        </Col>
      </Row>
    </DashboardLayout>
  );
};

export default SystemSettings;
